import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

export default function LogPage() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetch() {
      const { data } = await supabase
        .from('email_log')
        .select('*')
        .order('sent_at', { ascending: false })
        .limit(100);
      setLogs(data || []);
      setLoading(false);
    }
    fetch();
  }, []);

  function fmtDT(val) {
    if (!val) return '—';
    const d = new Date(val);
    return `${d.getMonth()+1}/${d.getDate()}/${String(d.getFullYear()).slice(2)} ${d.getHours() % 12 || 12}:${String(d.getMinutes()).padStart(2,'0')} ${d.getHours() >= 12 ? 'PM' : 'AM'}`;
  }

  if (loading) return <div style={{padding:40,textAlign:'center'}}><span className="spinner" /></div>;

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">Send Log</h1>
          <p className="page-subtitle">History of all customer report sends</p>
        </div>
      </div>

      <div className="card" style={{padding:0}}>
        {logs.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">📜</div>
            <h3>No sends yet</h3>
            <p>Send your first report from the Reports page</p>
          </div>
        ) : (
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Date/Time</th>
                  <th>Customer</th>
                  <th>Recipients</th>
                  <th>Loads</th>
                  <th>Cadence</th>
                  <th>Sent By</th>
                </tr>
              </thead>
              <tbody>
                {logs.map(log => (
                  <tr key={log.id}>
                    <td className="font-mono" style={{fontSize:12}}>{fmtDT(log.sent_at)}</td>
                    <td style={{fontWeight:500}}>{log.entity_name}</td>
                    <td style={{fontSize:12, color:'var(--text-secondary)'}}>
                      {(log.contact_emails || []).join(', ')}
                    </td>
                    <td>
                      <span className="badge badge-blue">{log.load_count}</span>
                    </td>
                    <td>
                      <span className="badge badge-gray">{log.cadence}</span>
                    </td>
                    <td style={{fontSize:12, color:'var(--text-secondary)'}}>{log.sent_by}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
